











import { Vue, Component } from 'vue-property-decorator'
import api from 'src/assets/api/rest'
import { signIn } from 'src/boot/auth'

@Component
export default class GoogleSignIn extends Vue {
  google = null
  loading: boolean = false
  error: boolean = false

  created () {
    // @ts-ignore
    window.gapi.load('auth2', () => {
      // @ts-ignore
      this.google = window.gapi.auth2.init({ client_id: process.env.GOOGLE_CLIENT_ID })
    })
  }

  async signIn () {
    this.loading = true
    if (this.google) try {
      // @ts-ignore
      const user = await this.google.signIn()
      const token = user.getAuthResponse().id_token
      const response = await api.post('/api/sign-in/google', { token })
      const accessToken = await response.text()
      signIn(accessToken)
      this.$emit('signin')
    } catch (e) {
      this.$emit('error')
    }
    this.loading = false
  }
}
